export const urlWithoutQuery = (uri: string) => uri.split('?').shift() as string
